import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const canvas = "omponents__Canvas__RegionThumb__PolygonRegionThumb_styles_ts-canvas-c1xuuswj";
export const canvasContainer = "omponents__Canvas__RegionThumb__PolygonRegionThumb_styles_ts-canvasContainer-c1x7rue3";

require("./PolygonRegionThumb.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PolygonRegionThumb.styles.ts");